import React from 'react';
import PropTypes from 'prop-types';
import { get } from 'lodash';

import AbstractFopContainer from './AbstractFopContainer';
import FopList from 'apps/fops/containers/FopList';
import RecommendedFopElementsFactory from 'apps/fops/components/fopElementsFactories/RecommendedFopElementsFactory';
import { componentTypes } from 'apps/analytics';
import { VIEW_TYPE_PREFERENCE_LIST } from 'apps/catalogue/actions/catalogue';
import { FopContainerBasketItems, FopContainerViewPreferenceShape, FopContainerVisibleFops } from '../types';

export default class RecommendedFopContainer extends AbstractFopContainer {
  static propTypes = {
    afterBasketQuantityChange: PropTypes.func,
    basketItems: FopContainerBasketItems,
    dispatch: PropTypes.func.isRequired,
    fopCollection: PropTypes.shape({
      sections: PropTypes.arrayOf(
        PropTypes.shape({
          attributes: PropTypes.shape({
            title: PropTypes.string,
          }).isRequired,
        })
      ).isRequired,
    }).isRequired,
    fopViewPreference: FopContainerViewPreferenceShape,
    gtmPageType: PropTypes.string,
    maxDisplayFops: PropTypes.number,
    productsBySku: PropTypes.object.isRequired,
    productWarnings: PropTypes.objectOf(PropTypes.array),
    quickMenuExpanded: PropTypes.object,
    title: PropTypes.string,
    shoppingListsModal: PropTypes.bool,
    subscriptionsBySku: PropTypes.object,
    visibleFops: FopContainerVisibleFops,
  };

  static defaultProps = {
    maxDisplayFops: 3,
  };

  get sectionTitle() {
    return (
      this.props.title ||
      this.props.fopCollection.sections[0].attributes.title ||
      'Recommended to you'
    );
  }

  render() {
    const { basketItems, fopCollection: { sections }, maxDisplayFops, productsBySku, productWarnings } = this.props;

    const recommendedFopElementsFactory = new RecommendedFopElementsFactory({
      basketItems,
      productsBySku,
      productWarnings,
      onQuantitySubmit: this.onQuantitySubmit,
      viewTypePreference: VIEW_TYPE_PREFERENCE_LIST,
    });

    // TODO class names are not correct filter-actions, filter-by should be made more general
    return (
      <div className="sidebar-element recommended-fops">
        <div className="sidebar-item filter-actions">
          <span className="filter-by show-for-xlarge">{this.sectionTitle}</span>
        </div>
        <FopList
          sections={sections}
          maxDisplayFops={maxDisplayFops}
          totalFops={get(sections, '[0].fops.length', -1)}
          productWarnings={productWarnings}
          fopElementsFactory={recommendedFopElementsFactory}
          fopType={componentTypes.FOP_SPONSORED}
          productsBySku={productsBySku}
          gtmPageType="Recommended items"
        />
      </div>
    );
  }
}
